import { Routes } from '@angular/router';
import { DEFAULT_MODAL_ROUTE_CONFIG } from '@app/common/default-modal-route-config';
import { DefaultRoutes } from '@app/common/default-routes';

export const DEFAULT_ROUTE_CONFIG: Routes = [
  DefaultRoutes.TODAY,
  DefaultRoutes.YOUR_BOARD,
  DefaultRoutes.COLLABORATION,
  DefaultRoutes.FIND_INFO,
  DefaultRoutes.APPS_TOOLS,
  DefaultRoutes.SETTINGS,
  DefaultRoutes.CREATE_SITE,
  DefaultRoutes.EDITOR_DASHBOARD,
  DefaultRoutes.FIRST_DAY,
  DefaultRoutes.ADMIN,
  DefaultRoutes.ABOUT,
  DefaultRoutes.PEOPLE,
  DefaultRoutes.BROADCAST_MESSAGES,
  DefaultRoutes.RESTAURANT,
  DefaultRoutes.KPI_CHARTS,
  DefaultRoutes.INFOBOXES,
  DefaultRoutes.MSTEAMS_AUTH,
  DefaultRoutes.POWER_BI,
  DefaultRoutes.PAGES,
  {
    path: '**', redirectTo: ''
  },
  ...DEFAULT_MODAL_ROUTE_CONFIG
];
